import ton_logo from "../../../assets/img/ton-logo.svg";
import {
  CollectionAvatar,
  CollectionBannerWrapper,
  CollectionCardWrapper,
  CollectionInfo,
  CollectionLink,
  CollectionPrice,
} from "./CollectionCard.styled";

export const CollectionCard = ({ product }) => {
  return (
    <CollectionCardWrapper to={`/marketplace/collections/${product.id}`}>
      <CollectionBannerWrapper>
        <img src={product?.banner} alt='banner' />
      </CollectionBannerWrapper>
      <CollectionAvatar>
        <img src={product?.owner?.ava} alt='avatar' />
      </CollectionAvatar>
      <CollectionInfo>
        <h5>{product?.title}</h5>
        <CollectionLink>
          by <a href='/'>{product?.owner?.name}</a>
        </CollectionLink>
        <CollectionPrice>
          <img alt='logo' src={ton_logo} />
          &nbsp;&nbsp;&nbsp;
          {product?.price}&nbsp; TON
        </CollectionPrice>
      </CollectionInfo>
    </CollectionCardWrapper>
  );
};
